export default __webpack_public_path__ + "static/media/MDI - twitter.655d1bd7.svg";